import { call, put, takeLatest } from 'redux-saga/effects';
import { getPercentDeposits } from '../../services/API';
import {
  actionTypes,
  requestFailure,
  requestSuccess,
} from 'modules/UserIncomes/redux/percentDeposits/actions';

function* getData() {
  const response = yield call(getPercentDeposits);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* percentDepositsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
